export class AttachmentTypeFilter {
    public IncludeInactive?: boolean;
    public BillingDiscrepancyRequestTypeID?: number;
}

export default AttachmentTypeFilter;